import { Link } from 'react-router-dom'
import { ImageOff, ShoppingBag } from 'lucide-react'
import type { MarketAsset } from '../types'
import { resolveAssetImage, short, sol } from '../utils'

export function NftCard({ asset }: { asset: MarketAsset }) {
  const image = resolveAssetImage(asset)
  return <article className="nft-card">
    <Link className="nft-media" to={`/nft/${asset.asset_id}`}>
      {image ? <img src={image} alt={asset.name || 'NFT'} loading="lazy" referrerPolicy="no-referrer"/> : <div className="media-missing"><ImageOff/><span>No image</span></div>}
      {asset.listed && <span className="listed-chip"><ShoppingBag size={13}/> Listed</span>}
    </Link>
    <div className="nft-body">
      <div className="nft-collection">{asset.collection_address ? <Link to={`/collection/${asset.collection_address}`}>{asset.collection_name || short(asset.collection_address)}</Link> : 'Solana NFT'}</div>
      <Link className="nft-name" to={`/nft/${asset.asset_id}`}>{asset.name || short(asset.asset_id)}</Link>
      <div className="nft-card-bottom"><span>{asset.listed ? 'Price' : 'Owner'}</span><b>{asset.listed ? sol(asset.price_lamports) : short(asset.owner_address)}</b></div>
    </div>
  </article>
}
